import classNames from 'classnames';

import { Button } from '@trello/nachos/button';
import type { TeamTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import styles from './BoardTag.less';
interface BoardTagProps {
  className?: string;
  text: string;
  selected: boolean;
  onClick: () => void;
}

export const BoardTag = ({
  className,
  text,
  selected,
  onClick,
}: BoardTagProps) => {
  return (
    <Button
      className={classNames(className, styles.boardTag, {
        [styles.boardTagSelected]: selected,
      })}
      onClick={onClick}
      data-testid={getTestId<TeamTestIds>('collection-button')}
    >
      {text}
    </Button>
  );
};
